import { motion, useReducedMotion } from "framer-motion";
import { useId } from "react";
import { areaPath } from "../utils/areaPath";

const WIDTH = 300;
const HEIGHT = 100;

type InterestAreaChartProps = {
  points: number[];
};

export function InterestAreaChart({ points }: InterestAreaChartProps) {
  const reduceMotion = useReducedMotion();
  const gradientId = useId();
  const d = areaPath(points, WIDTH, HEIGHT);

  return (
    <div className="rounded-ds-lg border-ds-border-strong h-32 overflow-hidden border sm:h-36">
      <svg
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        preserveAspectRatio="none"
        className="size-full"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--color-ds-brand-500)" />
            <stop
              offset="100%"
              stopColor="var(--color-ds-brand-500)"
              stopOpacity="0.12"
            />
          </linearGradient>
        </defs>
        {/* Uma curva se transforma na outra a cada troca de período. */}
        <motion.path
          fill={`url(#${gradientId})`}
          initial={false}
          animate={{ d }}
          transition={{
            duration: reduceMotion ? 0 : 1,
            ease: [0.16, 1, 0.3, 1],
          }}
        />
      </svg>
    </div>
  );
}
